import { render } from "./DelayNodeConfig.vue?vue&type=template&id=53c375a3&ts=true"
import script from "./DelayNodeConfig.vue?vue&type=script&lang=ts"
export * from "./DelayNodeConfig.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__